export interface Config {
    language: string,
    labels: {},
    userId: string,
    apiBasePath: string,

    // TODO: remove when SAP is not used anymore
    sourceSystem: SourceSystem
}

export enum SourceSystem {
    SAP = "SAP",
    ServiceNow = "ServiceNow"
}